function isString(value: any): boolean {
  return typeof value === 'string'
}

export default isString
